import { useEffect, useState } from "react";
import { IPaginationPayload } from "../../../../interfaces/shared/IPaginationPayload";
import { useGetAllCallsQuery } from "../../../../store/reservations/reservationsApi";
import moment from "moment";
import { NavLink } from "react-router-dom";
import Loading from "../../../../shared/Loading";
import { ICalls } from "../../../../interfaces/reservations/ICalls";
import Button from "../../../../shared/button";

const SaloonCalls = () => {
  const [paginationState, setPaginationState] = useState<IPaginationPayload>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [calls, setCalls] = useState<ICalls[]>([]);

  const { data, isLoading } = useGetAllCallsQuery(paginationState);

  console.log({ calls });

  const callStatus = (started: string, ended: string) => {
    const callStarted = moment(started);
    const callEnded = moment(ended);

    const callDuration = callEnded.diff(callStarted, "seconds");

    console.log({ callDuration });
    return callDuration > 3 ? (
      <span className="text-green-500">Answered </span>
    ) : (
      <span className="text-red-500">Declined </span>
    );
  };

  useEffect(() => {
    if (data) {
      setCalls([...calls, ...data.data.elements]);
    }
  }, [data]);

  const handleShowMore = () => {
    setPaginationState({
      ...paginationState,
      pageNumber: paginationState.pageNumber + 1,
    });
  };

  return (
    <div className="w-full my-3">
      {isLoading && <Loading />}
      {calls.map((call) => (
        <div className="mb-8 flex flex-wrap">
          <div>
            <div className="font-bold">
              {call.otherData.structuredData?.clientInformation ? (
                <>
                  {call.otherData.structuredData.clientInformation.name} (
                  {call.otherData.structuredData.clientInformation.email})
                </>
              ) : (
                "(no name received)"
              )}
            </div>
            <p className="text-sm text-saloon-details mt-0.5">
              {callStatus(call.otherData.callStarted, call.otherData.callEnded)}{" "}
              - {moment(call.updatedAt).format("DD/MM/YYYY HH:mm")}
            </p>
          </div>
          <div className="ml-auto">
            <NavLink to={call.callId}>
              <img src="/assets/saloon/view.svg" alt="view" />
            </NavLink>
          </div>
        </div>
      ))}
      {data?.data.page.hasNextPage && (
        <Button
          onClickButton={handleShowMore}
          label={"Show more"}
          loading={isLoading}
        />
      )}
    </div>
  );
};

export default SaloonCalls;
